import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="popover"
export default class extends Controller {

  confirm(event) {
    this.dispatch('confirmed')
  }

  decline(event) {
    this.dispatch('declined')
  }
}
